<template>
  <div class="category-item">
    <div class="content-wrapper" @click="fetchTimePackageItems">
      <li v-html="categoryItem.categoryName"></li>
      <svg
        class="arrow"
        width="12"
        height="12"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 16L16 1"
          stroke="#6D6963"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1 1H16V16"
          stroke="#6D6963"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "Category",
  props: {
    categoryItem: Object,
    categoryValue: Object,
    selectecCategoryId: String,
    forBeginners: Boolean,
    isExtendedCategory: Boolean,
  },
  
  methods: {
    async fetchTimePackageItems() {
      if (this.isExtendedCategory) {
        await this.$store.dispatch(
          "timePackages/fetchAllTimePackageItemsExtended",
          {
            categoryId: this.selectecCategoryId
              ? this.selectecCategoryId
              : this.categoryItem.id,
          }
        );
        this.$emit("selected");
      } else {
        await this.$store.dispatch("timePackages/fetchAllTimePackageItems", {
          categoryId: this.selectecCategoryId
            ? this.selectecCategoryId
            : this.categoryItem.id,
          forBeginners: this.forBeginners,
        });
        this.$emit("selected");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.category-item {
  width: fit-content;
  max-width: 300px;
  
  .content-wrapper {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    text-align: left;
    gap: 5px;
    
    li {
      list-style: none;
      color: #8b857d;
      text-transform: uppercase;
      font-family: 'Vollkorn SC', serif;
      padding-right: 8px; /* Spacing between text and arrow */
      
      a {
        color: white;
        font-size: 17px;
      }
    }
    
    .arrow {
      min-width: 12px;
      height: 12px;
    }
  }
}
</style>